import { render, staticRenderFns } from "./SafetyInfo.vue?vue&type=template&id=560298ff&scoped=true&"
import script from "./SafetyInfo.vue?vue&type=script&lang=js&"
export * from "./SafetyInfo.vue?vue&type=script&lang=js&"
import style0 from "./SafetyInfo.vue?vue&type=style&index=0&id=560298ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560298ff",
  null
  
)

export default component.exports